export default __webpack_public_path__ + "eb1c7ca89932aa2755d2f780108f22f7.svg";